




















































import {DiagramZoomType} from '@/enums/diagrams';
import {DiagramModule} from '@/store/modules/diagramModule';
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {DiagramSyncModeType} from './enums';

@Component({})
export default class ZoomMenuButton extends Vue {
  // Текс для бейджа
  get badgeText() {
    switch (this.zoomType) {
      case DiagramZoomType.X:
        return 'X';
      case DiagramZoomType.Y:
        return 'Y';
      case DiagramZoomType.XY:
        return 'X-Y';
      default:
        '';
    }
    return '';
  }

  // Список вариантов зума
  items = [
    {
      title: 'Ось X',
      value: DiagramZoomType.X,
    },
    {
      title: 'Ось Y',
      value: DiagramZoomType.Y,
    },
    {
      title: 'Оси X-Y',
      value: DiagramZoomType.XY,
    },
  ];

  isEnabled(item: any) {
    if (
      this.diagramStoreModule &&
      this.diagramStoreModule.syncModes.some(x => x.type === DiagramSyncModeType.ZoomX)
    )
      return item.value === DiagramZoomType.X;
    return true;
  }

  @Prop({required: false})
  diagramStoreModule!: DiagramModule;

  // Текущий тип зума
  @Prop({required: true})
  zoomType!: DiagramZoomType;

  @Prop({required: true, type: String, default: ''})
  tooltip!: string;

  @Prop({required: true, type: String, default: ''})
  alterTooltip!: string;

  @Prop({required: true, type: String})
  icon!: string;

  //null для исправления бага
  activeState: number | undefined | null = null;

  @Prop({required: true})
  applyStatus!: boolean;

  menu = false;

  key = 0;

  @Watch('menu')
  bugFix(value: boolean) {
    if (!value) {
      this.activeState = null;
      this.key++;
    }
  }

  @Prop({type: Boolean, default: false})
  disabled!: string;

  @Prop({default: () => ({})})
  activators!: {};

  click(e: any) {
    this.menu = false;
    this.$emit('click', e);
  }

  change() {
    this.$emit('change', this.activeState);
  }
}
